(function () {
  /*
    Tracking AddToCart (Meta Pixel + Shopify Analytics).
    Placé AVANT le guard .kb-page pour fonctionner sur toutes les pages (home, fiche produit).
    Contexte : les CTA sont soit des <form action="/cart/add" POST> (.kb-buy),
    soit le lien sticky bar (.kb-stickybar__btn), soit des liens <a href="/cart/add?...">
    sur la home. Aucun ne déclenchait l'événement AddToCart nativement.
    Règle absolue : ne JAMAIS bloquer l'ajout au panier. Si le pixel plante, la navigation
    doit se faire quand même (priorité vente).
  */
  var KB_ATC = {
   value: 39.00,        // ← PRIX COURANT. À CHANGER À CHAQUE HAUSSE DE PRIX (sinon le ROAS Meta est faux). Historique : 27,00 → 29,00 → 32,00 (26/08/2026)
    currency: 'EUR',
    content_ids: ['53939743031635'], // variant ID réel : même identifiant que l'event Purchase
    content_type: 'product',
    content_name: 'Kit Bailleur'
  };

  var atcFiredAt = 0;
  function fireAddToCart() {
    var now = Date.now();
    if (now - atcFiredAt < 800) return;
    atcFiredAt = now;
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', 'AddToCart', KB_ATC); } catch (e) {}
    }
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish('product_added_to_cart', {
          cartLine: { merchandise: { id: KB_ATC.content_ids[0] }, quantity: 1 }
        });
      } catch (e) {}
    }
  }

  /*
    Rend "Ajouter au panier" idempotent : quel que soit l'état de départ du panier
    (vide, déjà à 1, ou déjà buggé à N suite à un ancien clic), après cet appel le
    panier contient TOUJOURS exactement 1 exemplaire de ce variant avant de partir
    au paiement. Produit digital à exemplaire unique : un achat volontaire de
    plusieurs exemplaires se fait depuis /cart (icône panier, boutons +/-).
    Doc Shopify : /cart/change.js ne peut PAS créer une ligne (erreur si le variant
    n'est pas déjà dans le panier), donc :
      - variant absent du panier -> /cart/add.js (seul endpoint qui ajoute)
      - variant déjà présent, quantité quelconque -> /cart/change.js, id = line
        item key (pas le variant_id, au cas où plusieurs lignes le partageraient),
        quantity: 1
  */
  function kbVariantIdFromForm(form) {
    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function kbParseAddLink(href) {
    var qIndex = href.indexOf('?');
    var params = new URLSearchParams(qIndex > -1 ? href.slice(qIndex) : '');
    return { id: params.get('id'), returnTo: params.get('return_to') || '/cart' };
  }

  function kbGetCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function kbEnsureQuantityOne(variantId) {
    return kbGetCart().then(function (cart) {
      var existing = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId)) { existing = cart.items[i]; break; }
      }
      if (!existing) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      }
      if (existing.quantity === 1) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: existing.key, quantity: 1 })
      });
    });
  }

  var kbCartOpInFlight = null;
  function kbEnsureQuantityOneOnce(variantId) {
    if (kbCartOpInFlight) return kbCartOpInFlight;
    kbCartOpInFlight = kbEnsureQuantityOne(variantId).finally(function () { kbCartOpInFlight = null; });
    return kbCartOpInFlight;
  }

  function kbGoTo(url) { window.location.href = url; }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('kb-buy')) return;
    e.preventDefault();
    fireAddToCart();
    var variantId = kbVariantIdFromForm(form);
    if (!variantId) { kbGoTo('/checkout'); return; }
    kbEnsureQuantityOneOnce(variantId)
      .then(function () { kbGoTo('/checkout'); })
      .catch(function () { kbGoTo('/checkout'); });
  }, false);

  document.addEventListener('click', function (e) {
    var link = e.target.closest
      ? (e.target.closest('.kb-stickybar__btn') || e.target.closest('a[href*="/cart/add"]'))
      : null;
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    fireAddToCart();
    var parsed = kbParseAddLink(href);
    if (!parsed.id) { kbGoTo(parsed.returnTo); return; }
    kbEnsureQuantityOneOnce(parsed.id)
      .then(function () { kbGoTo(parsed.returnTo); })
      .catch(function () { kbGoTo(parsed.returnTo); });
  }, false);

  var root = document.querySelector('.kb-page');
  if (!root) return;

  var nav = root.querySelector('.nav');
  var stickybar = document.getElementById('kb-stickybar');
  var isHome = document.body.classList.contains('template-index-kb');
  var BAR_SHOW_AT = 300;   // px : la barre CTA apparaît après 300px

  var mobileMq = window.matchMedia('(max-width: 899px)');
  var lastY = window.scrollY || window.pageYOffset || 0;
  var HIDE_THRESHOLD = 5;

  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;

    if (nav) {
      if (!isHome) {
        nav.classList.add('scrolled');
        nav.classList.remove('at-top', 'nav-mid');
      } else if (y <= 10) {
        nav.classList.add('at-top');
        nav.classList.remove('nav-mid', 'scrolled');
      } else if (y <= 80) {
        nav.classList.add('nav-mid');
        nav.classList.remove('at-top', 'scrolled');
      } else {
        nav.classList.add('scrolled');
        nav.classList.remove('at-top', 'nav-mid');
      }
    }

    if (nav) {
      if (mobileMq.matches) {
        var delta = y - lastY;
        if (Math.abs(delta) > HIDE_THRESHOLD) {
          if (delta > 0 && y > 80) {
            nav.classList.add('nav-hidden');
          } else {
            nav.classList.remove('nav-hidden');
          }
          lastY = y;
        }
      } else {
        nav.classList.remove('nav-hidden');
        lastY = y;
      }
    }

    if (stickybar) {
      var show = y > BAR_SHOW_AT;
      stickybar.classList.toggle('show', show);
      stickybar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  var burger = document.getElementById('kb-burger');
  var drawer = document.getElementById('kb-drawer');
  if (burger && drawer) {
    var openDrawer = function () {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('kb-no-scroll');
    };
    var closeDrawer = function () {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('kb-no-scroll');
    };
    burger.addEventListener('click', openDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-drawer-close') || e.target.closest('[data-drawer-close]')) {
        closeDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  }

  var slider = document.getElementById('kb-slider');
  if (slider) {
    var track = document.getElementById('kb-slider-track');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.kb-slide'));
    var prevBtn = document.getElementById('kb-slider-prev');
    var nextBtn = document.getElementById('kb-slider-next');
    var dotsWrap = document.getElementById('kb-slider-dots');
    var index = 0;
    var count = slides.length;

    var dots = [];
    if (dotsWrap && count > 1) {
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'kb-slider__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Aller à l’image ' + (i + 1));
        (function (n) {
          dot.addEventListener('click', function () { goTo(n); });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function update() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = (index === 0);
      if (nextBtn) nextBtn.disabled = (index === count - 1);
    }

    function goTo(n) {
      index = Math.max(0, Math.min(count - 1, n));
      update();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(index - 1); }
      else if (e.key === 'ArrowRight') { goTo(index + 1); }
    });

    var startX = 0, startY = 0, swiping = false;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) goTo(index + 1); else goTo(index - 1);
      }
    }, { passive: true });

    update();
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = Array.prototype.slice.call(root.querySelectorAll('.reveal'));
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var el = e.target;
        var d = el.dataset.delay ? parseInt(el.dataset.delay, 10) : 0;
        setTimeout(function () { el.classList.add('in'); }, d);
        io.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();